import { useEffect, useState } from 'react'
import { postPortaria } from './portariaApi'
import { residentApi } from './residentApi'

type Slot = { startsAt: string; endsAt: string; available: boolean }
export function ReservationCalendar({ clientId, areas, resident = false }: { clientId: string; areas: { id: string; name: string }[]; resident?: boolean }) {
  const [areaId, setAreaId] = useState('')
  const [day, setDay] = useState(() => new Date().toLocaleDateString('en-CA'))
  const [slots, setSlots] = useState<Slot[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  useEffect(() => { setAreaId(areas[0]?.id ?? '') }, [clientId, areas[0]?.id])
  useEffect(() => {
    let active = true
    setSlots([]); setError('')
    if (!areaId || !day) return
    setLoading(true)
    const path = `areas/${areaId}/calendar`
    const request = resident ? residentApi<{ slots: Slot[] }>(path, { day }, 'POST') : postPortaria<{ slots: Slot[] }>(clientId, path, { day })
    request.then(result => { if (active) setSlots(result.slots) })
      .catch(() => { if (active) setError('Não foi possível consultar o calendário.') })
      .finally(() => { if (active) setLoading(false) })
    return () => { active = false }
  }, [clientId, areaId, day, resident])
  return <div className="portaria-card"><h3>Disponibilidade por dia</h3>
    <div className="portaria-form-grid"><label>Área<select value={areaId} onChange={event => setAreaId(event.target.value)}>{areas.map(area => <option key={area.id} value={area.id}>{area.name}</option>)}</select></label><label>Dia<input type="date" value={day} onChange={event => setDay(event.target.value)} /></label></div>
    {loading && <p role="status">Consultando horários…</p>}{error && <p role="alert">{error}</p>}
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(150px,1fr))', gap: 10, marginTop: 16 }}>{slots.map(slot => <div key={slot.startsAt} style={{ padding: 14, borderRadius: 12, background: slot.available ? '#e4f4ff' : '#f0f2f5', border: `1px solid ${slot.available ? '#7dc8fa' : '#d9dee5'}`, color: '#093659' }}><strong>{new Date(slot.startsAt).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}–{new Date(slot.endsAt).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}</strong><div>{slot.available ? 'Disponível' : 'Indisponível'}</div></div>)}</div>
    {!loading && !error && !slots.length && <p>Sem horário de funcionamento neste dia.</p>}
    <small>A confirmação da reserva verifica novamente as regras e a disponibilidade.</small>
  </div>
}
